import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2163e3ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"hero is-medium\" data-v-2163e3ce><div class=\"hero-body\" data-v-2163e3ce><div class=\"container has-text-centered\" data-v-2163e3ce><h1 class=\"title hero-body-text is-2\" data-v-2163e3ce>Wildlive Portal</h1><h2 class=\"subtitle hero-body-text is-4\" data-v-2163e3ce> Store and share your wildlife camera trap images </h2></div></div></section>", 1)
const _hoisted_2 = {
  class: "columns has-text-centered navbar is-secondary",
  style: {"margin-top":"0px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column is-1" }, null, -1))
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title is-3" }, "Projects", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Here you go an overview of the registered projects.")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Take a look at the statistics, follow the modeled information chain and find out more about the detected animals based on our machine learning technology. ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Click here for more")
const _hoisted_15 = { class: "column" }
const _hoisted_16 = { class: "card" }
const _hoisted_17 = { class: "card-content" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title is-3" }, "Station Setups", -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" In this section you can see a map-based visualization of our stations to observe animals in the nature undisturbed and not endangered from humans. ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode("The cameras work and communicate over long time without people in the areas. ")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Click here for more")
const _hoisted_26 = { class: "column" }
const _hoisted_27 = { class: "card" }
const _hoisted_28 = { class: "card-content" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title is-3" }, "Capture Events", -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Here you can go directly to the detected animals. ")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Registred citizen scientist, after logging in, can assist our project in labeling and correcting the detected animals. Other users can use the collected data based on the XYZ license. ")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Click here for more")
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column is-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("p", null, [
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _createVNode(_component_router_link, { to: "/showArea/projects" }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("p", null, [
              _hoisted_19,
              _hoisted_20,
              _hoisted_21,
              _hoisted_22,
              _hoisted_23,
              _hoisted_24,
              _createVNode(_component_router_link, { to: "/stationsetupsoverview" }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("p", null, [
              _hoisted_30,
              _hoisted_31,
              _hoisted_32,
              _hoisted_33,
              _hoisted_34,
              _hoisted_35,
              _createVNode(_component_router_link, { to: "/showArea/captureevent" }, {
                default: _withCtx(() => [
                  _hoisted_36
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _hoisted_37
    ])
  ]))
}